export { type FeaturedReviewProps, default as FeaturedReview } from './FeaturedReview';
